import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

// Define the shape of the LanguageContext
interface LanguageContextType {
    language: string; // 'Eng' or 'Nep'
    changeLanguage: (newLanguage: string) => void; // Function to change language
}

// Create context with a default undefined value (it will be provided later)
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Define the props type for the provider component
interface LanguageProviderProps {
    children: ReactNode; // ReactNode type to accept children
}

// The LanguageProvider component
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const lang = localStorage.getItem("lang"||"Eng")
    useEffect(()=>{

    },[lang])
    const [language, setLanguage] = useState<string>(localStorage.getItem('lang') || 'Eng');
    
     // Update language in localStorage whenever it changes
     const changeLanguage = (newLanguage: string) => {
        setLanguage(newLanguage);
        localStorage.setItem('lang', newLanguage); // Save the language in localStorage
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

// Custom hook to access LanguageContext
export const useLanguage = (): LanguageContextType => {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
